"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextByYearBookings = exports.getSubTextByYearBookings = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _localization = _interopRequireDefault(require("../../../../localization"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getTextByYearBookings = exports.getTextByYearBookings = function getTextByYearBookings(yearBookings) {
  return R.call(R.cond([[function (bookings) {
    return bookings >= 1 && bookings <= 4;
  }, function () {
    return _localization.default.t('OFFER_DETAILS:LIMIT_FIVE_BOOKINGS_TEXT');
  }], [function (bookings) {
    return bookings >= 5;
  }, function () {
    return _localization.default.t('OFFER_DETAILS:BOOKINGS_BY_COUNT_TEXT', {
      countBookings: yearBookings.bookings
    });
  }], [R.T, function () {
    return _localization.default.t('OFFER_DETAILS:ZERO_BOOKINGS_TEXT');
  }]]), yearBookings.bookings);
};
var getSubTextByYearBookings = exports.getSubTextByYearBookings = function getSubTextByYearBookings(yearBookings, touristsTranslation) {
  return yearBookings.bookings >= 5 ? _localization.default.t('OFFER_DETAILS:BOOKINGS_BY_YEAR_FULL_TEXT', {
    touristsCount: yearBookings.tourists,
    touristsWord: touristsTranslation(yearBookings.tourists)
  }) : _localization.default.t('OFFER_DETAILS:BOOKINGS_BY_YEAR_TEXT');
};